module.exports = __webpack_public_path__ + "img/32559561172cdbbe438a1e3164ab0c4f.svg";